// Logowanie, rejestracja, reset hasła, weryfikacja kodu (MFA), profil, strona 404 i panel
// boczny layoutu publicznego. Mockup nie ma żadnego z tych ekranów (jest wyłącznie panel po
// zalogowaniu), więc cały ten plik to tłumaczenie własne.
//
// Teksty zwracane przez backend (błędy logowania i rejestracji, `message` z API) wyświetlamy
// bez zmian. Tu są tylko te, które wymyśla front: walidacje, powiadomienia, fallbacki.
//
// VERIFY: cały plik.
export default {
  fields: {
    email: 'Adres e-mail',
    password: 'Hasło',
    currentPassword: 'Obecne hasło',
    newPassword: 'Nowe hasło',
    confirmPassword: 'Potwierdź hasło',
    firstName: 'Imię',
    lastName: 'Nazwisko',
    companyName: 'Nazwa firmy',
  },
  // Walidacje formularzy poza tymi, które są wspólne (`common:validation.*`).
  validation: {
    firstNameRequired: 'Podaj imię',
    lastNameRequired: 'Podaj nazwisko',
    companyNameRequired: 'Podaj nazwę firmy',
    currentPasswordRequired: 'Podaj obecne hasło',
    newPasswordRequired: 'Podaj nowe hasło',
    confirmPasswordRequired: 'Potwierdź hasło',
    passwordsMismatch: 'Hasła nie są takie same',
    passwordMinLength: 'Hasło musi mieć co najmniej 8 znaków',
    passwordNumber: 'Hasło musi zawierać co najmniej jedną cyfrę',
    passwordUppercase: 'Hasło musi zawierać co najmniej jedną wielką literę',
    passwordSpecial: 'Hasło musi zawierać co najmniej jeden znak specjalny',
  },
  // Lista wymagań pod polem hasła (reset hasła i zmiana hasła w profilu).
  passwordRules: {
    minLength: 'Minimum 8 znaków',
    uppercase: 'Minimum jedna wielka litera',
    uppercaseExtended: 'Minimum jedna wielka litera (A-Z, ĄĆĘŁŃÓŚŹŻ)',
    special: 'Minimum jeden znak specjalny (!, @, #, $, % itp.)',
    number: 'Minimum jedna cyfra',
  },
  signIn: {
    forgotPassword: 'Nie pamiętasz hasła?',
    submit: 'Zaloguj się',
    // Tagi <link> podmienia <Trans components={{ link: <Link ... /> }} />, dzięki czemu
    // zdanie tłumaczy się w całości, a nie w kawałkach wokół linku.
    noAccount: 'Nie masz konta? <link>Zarejestruj się</link>',
    support: 'Coś nie działa? <link>Zgłoś problem</link>',
    // Powiadomienie przy 401, złożone we froncie (backend odsyła tylko status).
    invalidCredentials:
      'Nie znaleziono konta pasującego do podanego adresu e-mail i hasła. Sprawdź dane i spróbuj ponownie.',
  },
  signUp: {
    submit: 'Utwórz konto',
    haveAccount: 'Masz już konto? <link>Zaloguj się</link>',
    // Fallback, gdy backend nie odesłał listy błędów.
    failed: 'Rejestracja nie powiodła się. Spróbuj ponownie.',
  },
  forgotPassword: {
    title: 'Nie pamiętasz hasła?',
    description: 'Podaj adres e-mail, a wyślemy instrukcje resetowania hasła.',
    submit: 'Wyślij instrukcje resetowania',
  },
  checkEmail: {
    title: 'Sprawdź skrzynkę e-mail',
    // <bold> podmienia <Trans> na wyróżniony adres.
    instructions: 'Sprawdź adres <bold>{{email}}</bold>: wysłano tam instrukcje resetowania hasła.',
    resend: 'Wyślij ponownie',
    resendIn: 'Wyślij ponownie za {{time}}',
    wrongEmail: 'Adres {{email}} jest niepoprawny?',
    changeEmail: 'Zmień adres e-mail',
  },
  resetPassword: {
    title: 'Zresetuj hasło',
    submit: 'Zresetuj hasło',
    success: 'Hasło zostało zmienione. Zaloguj się.',
  },
  // Weryfikacja kodem po zalogowaniu (MFA).
  verification: {
    method: {
      title: 'Wybierz metodę weryfikacji',
      description: 'W jaki sposób odebrać kod weryfikacyjny?',
      email: 'E-mail',
    },
    code: {
      title: 'Wpisz kod weryfikacyjny',
      required: 'Podaj kod weryfikacyjny',
      changeMethodQuestion: 'Zmienić metodę weryfikacji?',
      changeMethod: 'Zmień metodę weryfikacji',
    },
    timer: {
      notReceived: 'Nie dotarł kod weryfikacyjny?',
      resendIn: 'Wyślij nowy kod za {{time}}',
      resend: 'Wyślij nowy kod',
    },
    codeSent: 'Kod weryfikacyjny został wysłany wybraną metodą (SMS lub e-mail).',
    methodUnavailable: 'Nie można użyć tej metody weryfikacji. Wybierz inną.',
    sendFailed: 'Coś poszło nie tak. Spróbuj ponownie.',
    invalidCode: 'Nieprawidłowy kod weryfikacyjny. Spróbuj ponownie.',
  },
  profile: {
    tabs: {
      personalInfo: 'Dane osobowe',
      security: 'Bezpieczeństwo',
    },
    name: 'Imię i nazwisko',
    phone: 'Numer telefonu',
    changePassword: 'Zmień hasło',
    logoutNotice: 'Zmiana hasła spowoduje wylogowanie.',
    passwordChanged: 'Hasło zostało zmienione. Zaloguj się ponownie.',
    // Fallback, gdy backend nie odesłał treści błędu.
    passwordChangeFailed: 'Nieznany błąd',
  },
  notFound: {
    title: 'Nie znaleziono strony',
    backHome: 'Wróć na stronę główną',
    backPrevious: 'Wróć na poprzednią stronę',
  },
  // Panel boczny obok formularzy logowania i rejestracji.
  publicLayout: {
    heading: 'Rozwiązania kontaktowe oparte na AI',
    text: 'Koniec z długim oczekiwaniem i sfrustrowanymi klientami. Większa efektywność i satysfakcja klientów jak nigdy dotąd.',
  },
} as const;
